import { fileAccessService } from 'app/services/fileAccess.service';
import { updateTransactionReceipt } from 'app/pages/store/transactionsSlice';
import { deleteTransactionToReceiptUpload } from 'app/services/reimbursementService';
import { useAppDispatch } from 'app/store';
import { useCallback } from 'react';

interface DeleteReceiptParams {
  document: string;
  receiptId: string;
  paidolId: string;
  transactionId: string;
  isLastReceipt: boolean;
}

export function useDeleteReceipt() {
  const dispatch = useAppDispatch();

  const deleteReceipt = useCallback(
    async ({ document, receiptId, paidolId, transactionId, isLastReceipt }: DeleteReceiptParams) => {
      await fileAccessService.deleteFile(document);
      await deleteTransactionToReceiptUpload(receiptId);

      if (isLastReceipt) {
        await dispatch(
          updateTransactionReceipt({
            paidolId,
            id: transactionId,
            receiptPath: null,
            receiptId: null,
          })
        );
      }
    },
    [dispatch]
  );

  return { deleteReceipt };
}
